// @flow @format
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Header from '../../../../components/Header';
import UserSelectContainer from '../../../../containers/UserSelectContainer';
import MachineSelectContainer from '../../../../containers/MachineSelectContainer';
import './Header.css';

type Props = {
	logout: () => void,
};

class FilesHeader extends Component<Props> {
	static contextTypes = {
		router: PropTypes.object.isRequired,
	};

	render() {
		return (
			<Header>
				<div className="FilesHeader__Navigation">
					<div className="FilesHeader__Navigation__Item">
						<UserSelectContainer />
					</div>
					<div className="FilesHeader__Navigation__Item">
						<MachineSelectContainer />
					</div>

					<div className="FilesHeader__Navigation__Item">
						<button
							className="FilesHeader__Navigation__Item__Button"
							onClick={() => {
								this.props.logout();
								this.context.router.replace('/login');
							}}
						>
							Cerrar sesion
						</button>
					</div>
				</div>
			</Header>
		);
	}
}

FilesHeader.propTypes = {
	logout: PropTypes.func.isRequired,
};

export default FilesHeader;



// WEBPACK FOOTER //
// ./src/routes/Explorer/components/Header/Header.js